const normalizedText = (value) => String(value || '').trim();

const joinRequirements = (items, language) => {
  if (items.length <= 1) return items[0] || '';
  if (language === 'he') {
    return `${items.slice(0, -1).join(', ')} ו${items.at(-1)}`;
  }
  return `${items.slice(0, -1).join(', ')} and ${items.at(-1)}`;
};

export const evaluateCheckoutReadiness = ({
  processing = false,
  name = '',
  phone = '',
  email = '',
  withDelivery = false,
  street = '',
  city = '',
  agreedToTerms = false,
} = {}) => {
  const contactComplete = Boolean(
    normalizedText(name) && normalizedText(phone) && normalizedText(email),
  );
  const missingDeliveryFields = withDelivery
    ? [
      !normalizedText(street) ? 'street' : null,
      !normalizedText(city) ? 'city' : null,
    ].filter(Boolean)
    : [];
  const deliveryAddressComplete = missingDeliveryFields.length === 0;

  return {
    processing: Boolean(processing),
    contactComplete,
    deliveryAddressComplete,
    missingDeliveryFields,
    agreedToTerms: Boolean(agreedToTerms),
    ready: !processing && contactComplete && deliveryAddressComplete && Boolean(agreedToTerms),
  };
};

export const getCheckoutReadinessMessage = (readiness, language = 'he') => {
  if (readiness.processing) {
    return language === 'he'
      ? 'הבקשה התקבלה ומעובדת כעת…'
      : 'Your request was received and is being processed…';
  }

  const requirements = [];
  if (!readiness.contactComplete) {
    requirements.push(language === 'he' ? 'שם, טלפון ואימייל' : 'your name, phone and email');
  }
  if (!readiness.deliveryAddressComplete) {
    const missingStreet = readiness.missingDeliveryFields.includes('street');
    const missingCity = readiness.missingDeliveryFields.includes('city');
    if (language === 'he') {
      requirements.push(
        missingStreet && missingCity
          ? 'רחוב ומספר בית ועיר למשלוח'
          : (missingStreet ? 'רחוב ומספר בית למשלוח' : 'עיר למשלוח'),
      );
    } else {
      requirements.push(
        missingStreet && missingCity
          ? 'the delivery street, house number and city'
          : (missingStreet ? 'the delivery street and house number' : 'the delivery city'),
      );
    }
  }
  if (!readiness.agreedToTerms) {
    requirements.push(language === 'he' ? 'אישור תנאי השימוש' : 'acceptance of the terms');
  }

  if (requirements.length > 0) {
    const joined = joinRequirements(requirements, language);
    return language === 'he'
      ? `כדי להמשיך יש להשלים ${joined}.`
      : `To continue, complete ${joined}.`;
  }

  return language === 'he'
    ? 'הפרטים הושלמו. אפשר להמשיך.'
    : 'Your details are complete. You can continue.';
};
